"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidComponent = void 0;
var FluidComponent;
(function (FluidComponent) {
    FluidComponent["FLUID_ACCORDION"] = "fluid-accordion";
    FluidComponent["FLUID_ACCORDION_PANEL"] = "fluid-accordion-panel";
    FluidComponent["FLUID_ACTIONS"] = "fluid-actions";
    FluidComponent["FLUID_ALERT"] = "fluid-alert";
    FluidComponent["FLUID_BADGE"] = "fluid-badge";
    FluidComponent["FLUID_BAR_CHART"] = "fluid-bar-chart";
    FluidComponent["FLUID_BREADCRUMB"] = "fluid-breadcrumb";
    FluidComponent["FLUID_BUTTON"] = "fluid-button";
    FluidComponent["FLUID_BUTTON_GROUP"] = "fluid-button-group";
    FluidComponent["FLUID_CARD"] = "fluid-card";
    FluidComponent["FLUID_CAROUSEL"] = "fluid-carousel";
    FluidComponent["FLUID_CODE_BLOCK"] = "fluid-code-block";
    FluidComponent["FLUID_COMBO_BOX"] = "fluid-combo-box";
    FluidComponent["FLUID_CONFIRMATION_DIALOG"] = "fluid-confirmation-dialog";
    FluidComponent["FLUID_CONTAINER"] = "fluid-container";
    FluidComponent["FLUID_CONTENT_COLLAPSE"] = "fluid-content-collapse";
    FluidComponent["FLUID_CONTEXT_MENU"] = "fluid-context-menu";
    FluidComponent["FLUID_CSAT"] = "fluid-csat";
    FluidComponent["FLUID_CURRENCY_FIELD"] = "fluid-currency-field";
    FluidComponent["FLUID_DATA_LAYER"] = "fluid-data-layer";
    FluidComponent["FLUID_DATE_RANGE"] = "fluid-date-range";
    FluidComponent["FLUID_DATEPICKER"] = "fluid-datepicker";
    FluidComponent["FLUID_DIVIDER"] = "fluid-divider";
    FluidComponent["FLUID_DOM_CLIPPER"] = "fluid-dom-clipper";
    FluidComponent["FLUID_DRAWER"] = "fluid-drawer";
    FluidComponent["FLUID_DROPDOWN_BUTTON"] = "fluid-dropdown-button";
    FluidComponent["FLUID_EMPTY_STATE_CONTAINER"] = "fluid-empty-state-container";
    FluidComponent["FLUID_FAQ"] = "fluid-faq";
    FluidComponent["FLUID_FILE_UPLOAD"] = "fluid-file-upload";
    FluidComponent["FLUID_FOOTER"] = "fluid-footer";
    FluidComponent["FLUID_FOOTER_ACTIONS"] = "fluid-footer-actions";
    FluidComponent["FLUID_FOOTER_CONTENT"] = "fluid-footer-content";
    FluidComponent["FLUID_FORM"] = "fluid-form";
    FluidComponent["FLUID_FORM_ARRAY"] = "fluid-form-array";
    FluidComponent["FLUID_GRID"] = "fluid-grid";
    FluidComponent["FLUID_GRID_ITEM"] = "fluid-grid-item";
    FluidComponent["FLUID_HEADER"] = "fluid-header";
    FluidComponent["FLUID_HEADER_ACTIONS"] = "fluid-header-actions";
    FluidComponent["FLUID_I18N_PROVIDER"] = "fluid-i18n-provider";
    FluidComponent["FLUID_ICON"] = "fluid-icon";
    FluidComponent["FLUID_IMAGE"] = "fluid-image";
    FluidComponent["FLUID_INPUT_FIELD"] = "fluid-input-field";
    FluidComponent["FLUID_LABEL"] = "fluid-label";
    FluidComponent["FLUID_LINE_CHART"] = "fluid-line-chart";
    FluidComponent["FLUID_LINEAR_PROGRESS"] = "fluid-linear-progress";
    FluidComponent["FLUID_LINK"] = "fluid-link";
    FluidComponent["FLUID_LOADING_SKELETON"] = "fluid-loading-skeleton";
    FluidComponent["FLUID_LOADING_SPINNER"] = "fluid-loading-spinner";
    FluidComponent["FLUID_MATRIX_QUESTIONS"] = "fluid-matrix-questions";
    FluidComponent["FLUID_MODAL"] = "fluid-modal";
    FluidComponent["FLUID_PAGE"] = "fluid-page";
    FluidComponent["FLUID_PAGE_CONTEXT_BAR"] = "fluid-page-context-bar";
    FluidComponent["FLUID_PAGINATOR"] = "fluid-paginator";
    FluidComponent["FLUID_PIE_CHART"] = "fluid-pie-chart";
    FluidComponent["FLUID_POPOVER"] = "fluid-popover";
    FluidComponent["FLUID_RADIO_GROUP"] = "fluid-radio-group";
    FluidComponent["FLUID_RANGE_CHART"] = "fluid-range-chart";
    FluidComponent["FLUID_RATING"] = "fluid-rating";
    FluidComponent["FLUID_SEARCH_BOX"] = "fluid-search-box";
    FluidComponent["FLUID_SECTION_DETAIL"] = "fluid-section-detail";
    FluidComponent["FLUID_SELECT"] = "fluid-select";
    FluidComponent["FLUID_SIDEBAR"] = "fluid-sidebar";
    FluidComponent["FLUID_STACKEDBAR_HORIZONTAL"] = "fluid-stackedbar-horizontal";
    FluidComponent["FLUID_STEP"] = "fluid-step";
    FluidComponent["FLUID_STEPPER"] = "fluid-stepper";
    FluidComponent["FLUID_STICKY_BUTTON"] = "fluid-sticky-button";
    FluidComponent["FLUID_TAB"] = "fluid-tab";
    FluidComponent["FLUID_TAB_NAVIGATION"] = "fluid-tab-navigation";
    FluidComponent["FLUID_TABLE"] = "fluid-table";
    FluidComponent["FLUID_TABS"] = "fluid-tabs";
    FluidComponent["FLUID_TEXT"] = "fluid-text";
    FluidComponent["FLUID_TEXT_AREA"] = "fluid-text-area";
    FluidComponent["FLUID_THEME_PROVIDER"] = "fluid-theme-provider";
    FluidComponent["FLUID_TITLE"] = "fluid-title";
    FluidComponent["FLUID_TOGGLE"] = "fluid-toggle";
    FluidComponent["FLUID_TOGGLE_GROUP"] = "fluid-toggle-group";
    FluidComponent["FLUID_TOUR"] = "fluid-tour";
    FluidComponent["FLUID_TREE_MENU"] = "fluid-tree-menu";
    FluidComponent["FLUID_VEGA"] = "fluid-vega";
})(FluidComponent = exports.FluidComponent || (exports.FluidComponent = {}));
